import React, { useEffect, useState } from 'react';
import { Select, Tabs, Tab } from '@veneer/core';
import { useTranslation } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import ConnectAPI from '../../../services/api';
import { numberFormatComma } from '../../../common/js/utils/numberFormat';


const BonusTable = (props) => {
  const connectApi = new ConnectAPI();
  const { t, i18n } = useTranslation();
  const [activeTabIndex, setactiveTabIndex] = useState(0);
  const [countrySelected, setcountrySelected] = useState('');
  const [programtable, setprogramtable]=useState([]);
  const [standarclick,setstandarclick]=useState([]);
  const [catsubregions, setcatsubregions]=useState([]);
  const subregions = JSON.parse(localStorage.getItem("currentUser")).idSubRegion;

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
        if (ur==window.location.pathname){
            validate=true;
        }
    });
    if (validate==false){
        const { history } = props;
        history.push({
            pathname: '/' 
        });
    }
    //end validate
    connectApi
        .get(
          "api/Channels/getbonustable",
          "",
          consolidconfig
        )

    if (subregions.split(',').findIndex(x => x.trim() == '31') > -1) {
      
      setcountrySelected(31)
    }
    if (subregions.split(',').findIndex(x => x.trim() == '32') > -1) {
      setcountrySelected(32)
    }
    if (subregions.split(',').findIndex(x => x.trim() == '3') > -1) {
      setcountrySelected(3)
    }
    if (subregions.split(',').findIndex(x => x.trim() == '2') > -1) {
      setcountrySelected(2)
    }
  }, [subregions]);
  const groupBy=(array,key)=>{
    return array.reduce((result,currentvalue)=>{
      if (!result[currentvalue[key]]){
        result[currentvalue[key]]=[];
      } 
      result[currentvalue[key]].push(currentvalue);
      return result;
    },{});
  }

  const consolidconfig = (status, data) => {

    setcatsubregions(data.subregions.filter(p => Number(p.idSubRegion) !== 1));
    setstandarclick(data.standarclick);

    const grouped = groupBy(data.bonustable, 'idProgram');
    const formattedData = Object.keys(grouped).map(id => ({ 
      idProgram: id,
      idSubRegion: grouped[id][0].idSubRegion, 
      classification: grouped[id][0].classification, 
      rows: grouped[id]
    })); 
    setprogramtable(formattedData)
  }
  const selectTab = (event) => (index) => {
    setactiveTabIndex(index);
  };
  const RenderTabs = () => {
    const mainTab = {
      id: 0,
      label: <Trans i18nKey="bonus table" />,
      content: (
        <div class="bonus-card-container">
          {(subregions.split(',').findIndex(x => x.trim() == '2') > -1) ? (

           programtable && programtable.filter(p => Number(p.idSubRegion) === 2)
            .map((programa) => {
              return (
                    <div className="bonus-card" key={programa.idProgram}>
                        <h5><Trans i18nKey="bonustable.series3AB" /></h5>
                        <br />
                        <p>
                            <strong><Trans i18nKey="bonustable.model" /></strong> {programa.classification}
                        </p>
                        <br />

                        <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                            <thead>
                                <tr>
                                    <th><Trans i18nKey="bonustable.table1" /></th>
                                    <th><Trans i18nKey="bonustable.table2" /></th>
                                    <th><Trans i18nKey="bonustable.table4" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {programa.rows.map((fila, index) => (
                                    <tr key={index}>
                                        <td>{numberFormatComma(fila.minPrint)}</td>
                                        <td>{numberFormatComma(fila.maxPrint)}</td>
                                        <td>{numberFormatComma(fila.currentProgram)}%</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
              );
            })
          ) : undefined}
          {(subregions.split(',').findIndex(x => x.trim() == '3') > -1) ? (
            programtable && programtable.filter(p => Number(p.idSubRegion) === 3)
            .map((programa) => {
              return (
                    <div className="bonus-card" key={programa.idProgram}>
                        <h5><Trans i18nKey="bonustable.series3AM" /></h5>
                        <br />
                        <p>
                            <strong><Trans i18nKey="bonustable.model" /></strong> {programa.classification}
                        </p>
                        <br />

                        <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                            <thead>
                                <tr>
                                    <th><Trans i18nKey="bonustable.table1" /></th>
                                    <th><Trans i18nKey="bonustable.table2" /></th>
                                    <th><Trans i18nKey="bonustable.table4" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {programa.rows.map((fila, index) => (
                                    <tr key={index}>
                                        <td>{numberFormatComma(fila.minPrint)}</td>
                                        <td>{numberFormatComma(fila.maxPrint)}</td>
                                        <td>{numberFormatComma(fila.currentProgram)}%</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
              );
            })
           
          ) : undefined}
          {(subregions.split(',').findIndex(x => x.trim() == '31' || x == '32') > -1) ? (
            programtable && programtable.filter(p => Number(p.idSubRegion) === 30)
            .map((programa) => {
              return (
                    <div className="bonus-card" key={programa.idProgram}>
                        <h5><Trans i18nKey="bonustable.series3MCA" /></h5>
                        <br />
                        <p>
                            <strong><Trans i18nKey="bonustable.model" /></strong> {programa.classification}
                        </p>
                        <br />

                        <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                            <thead>
                                <tr>
                                    <th><Trans i18nKey="bonustable.table1" /></th>
                                    <th><Trans i18nKey="bonustable.table2" /></th>
                                    <th><Trans i18nKey="bonustable.table4" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {programa.rows.map((fila, index) => (
                                    <tr key={index}>
                                        <td>{numberFormatComma(fila.minPrint)}</td>
                                        <td>{numberFormatComma(fila.maxPrint)}</td>
                                        <td>{numberFormatComma(fila.currentProgram)}%</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
              );
            })

           
          ) : undefined}
        </div>
      ),
    };



    useEffect(() => {
      //validate location
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      let validate=false;
      currentUser.urls.forEach(ur=>{
          if (ur==window.location.pathname){
              validate=true;
          }
      });
      if (validate==false){
          const { history } = props;
          history.push({
              pathname: '/' 
          });
      }
      //end validate
      countryTable();
    }, [countrySelected]);

  
    const countryTable = () => {
      const result = standarclick.filter(p => 
        p.idSubRegion && 
        String(p.idSubRegion).split(',').map(Number).includes(Number(countrySelected))
      );

      const groupedByTier = result.reduce((acc, item) => {
        if (!acc[item.idProgram]) {
          acc[item.idProgram] = {
            name: item.classification,
            columns: new Set(), 
            tiers: {} 
          };
        }

        const prog = acc[item.idProgram];
        const tierKey = `${item.minPrint}-${item.maxPrint}`; 
        
        if (!prog.tiers[tierKey]) {
          prog.tiers[tierKey] = {
            min: item.minPrint,
            max: item.maxPrint,
            values: {}
          };
        }

        prog.tiers[tierKey].values[item.columName] = item.value;
        prog.columns.add(item.columName);

        return acc;
      }, {});
        
      return (
        <>
          <div className="bonus-card-container">
            {Object.keys(groupedByTier).map((progId) => {
              const program = groupedByTier[progId];
              const columnNames = Array.from(program.columns).sort();
              const columnFriendlyNames = {
                konly: 'Black',
                other: 'Other Colors (*)',
                oneshot: 'One Shot',
                ecomode: 'Eco Mode',
                white: 'White'
              };

              return (
                <div className="bonus-card" key={progId} style={{ marginBottom: '30px' }}>
                  <h5>HP Indigo {program.name} - Click price HP to End user</h5>
                  <br />
                  <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                    <thead>
                      <tr>
                        <th className="text-center">TIERS</th>
                        <th className="text-center">Min Clicks</th>
                        <th className="text-center">Max Clicks</th>
                        {columnNames.map(col => (
                          <th key={col} className="text-center">
                            {columnFriendlyNames[col] || col.toUpperCase()}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.values(program.tiers).map((tierData, index) => (
                        <tr key={index}>
                          <td className="text-center"><strong>TIER {index + 1}</strong></td>
                          <td className="text-center">{tierData.min.toLocaleString()}</td>
                          <td className="text-center">
                            {tierData.max > 900000000 ? '∞' : tierData.max.toLocaleString()}
                          </td>
                          
                          {columnNames.map(col => (
                            <td key={col} className="text-center">
                              {tierData.values[col] 
                                ? `$${tierData.values[col].toFixed(4)}` 
                                : '-'}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })}
          </div>
        </>
      );
      
    };

    const defaultTable = () => {
      return <div></div>;
    };

    const countrySelect = () => {
      const handleStatusChange = (name) => (event) => {
        console.log(event.value);
        setcountrySelected(event.value);
      };

      const getSelectOptions = () => {
        const options = catsubregions.filter(p => subregions.includes(Number(p.idSubRegion))).map(p => ({
          value: p.idSubRegion, 
          label: p.name
        }));
        return options;
      }

      return (
        <div
          style={{
            width: '170px',
            marginBottom: '16px',
          }}
        >
          <Select
            name="type"
            onChange={handleStatusChange()}
            options={getSelectOptions()}
            value={[countrySelected]}
            clearIcon={false}
          ></Select>
        </div>
      );
    };

    
    const secondTab = {
      // <Tab key="secondTab" title="Click Series 4" onClick={selectTab(1)}>
      id: 2,
      label: 'Click Series 4',
      content: (
        <div>
          <br />
          {countrySelect()}

          {countryTable()}

          <div style={{ marginTop: '16px', marginLeft: '16px' }}>
            <p>
              <strong><Trans i18nKey="bonustable.notes1" />:</strong>
            </p>
            <p>
              <strong>
                <Trans i18nKey="bonustable.notes2" />
              </strong>
            </p>
            <p>
              <strong><Trans i18nKey="bonustable.notes3" /></strong>
            </p>
            <p>
              <strong><Trans i18nKey="bonustable.notes4" /></strong>
            </p>
            <ul style={{ marginLeft: '30px' }}>
              <li>
                <Trans i18nKey="bonustable.notes5" />
              </li>
              <li>
                <Trans i18nKey="bonustable.notes6" />
              </li>
            </ul>
          </div>
        </div>
      ),
    };
    const list = [mainTab];
    if([9,10,11,12].includes(JSON.parse(localStorage.getItem("currentUser")).idRole)){

    }else{
      list.push(secondTab);
    }
    //const list = [mainTab];
    const tab = (
      <Tabs
        controlId="default"
        onChangeTab={selectTab()}
        selectedTabId={activeTabIndex}
        tabs={list}
      >
        {/* {list} */}
      </Tabs>
    );

    return tab;
  };

  return (
    <div>
      <br />
      <h4 style={{ marginBottom: '16px' }}><Trans i18nKey="supplies program" /></h4>
      <p>
        <Trans i18nKey="supplies program txt" />{' '}
      </p>
      <p>
        <Trans i18nKey="supplies program txt 2" />
      </p>
      <p> <Trans i18nKey="supplies program txt 3" /></p>

      <br />
      <RenderTabs />
      <br />
      <br />
    </div>
  );
};

export default withTranslation()(BonusTable);